'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('guia', {
                parent: 'entity',
                url: '/guias',
                data: {
                    roles: ['ROLE_USER'],
                    pageTitle: 'nfseApp.guia.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/guia/guias.html',
                        controller: 'GuiaController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('guia');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('guia.detail', {
                parent: 'entity',
                url: '/guia/{id}',
                data: {
                    roles: ['ROLE_USER'],
                    pageTitle: 'nfseApp.guia.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/guia/guia-detail.html',
                        controller: 'GuiaDetailController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('guia');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Guia', function($stateParams, Guia) {
                        return Guia.get({id : $stateParams.id});
                    }]
                }
            })
            .state('guia.new', {
                parent: 'guia',
                url: '/new',
                data: {
                    roles: ['ROLE_USER'],
                },
                onEnter: ['$stateParams', '$state', '$modal', function($stateParams, $state, $modal) {
                    $modal.open({
                        templateUrl: 'app/entities/guia/guia-dialog.html',
                        controller: 'GuiaDialogController',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {guia: null, valor: null, dataVencimento: null, id: null};
                            }
                        }
                    }).result.then(function(result) {
                        $state.go('guia', null, { reload: true });
                    }, function() {
                        $state.go('guia');
                    })
                }]
            })
            .state('guia.edit', {
                parent: 'guia',
                url: '/{id}/edit',
                data: {
                    roles: ['ROLE_USER'],
                },
                onEnter: ['$stateParams', '$state', '$modal', function($stateParams, $state, $modal) {
                    $modal.open({
                        templateUrl: 'app/entities/guia/guia-dialog.html',
                        controller: 'GuiaDialogController',
                        size: 'lg',
                        resolve: {
                            entity: ['Guia', function(Guia) {
                                return Guia.get({id : $stateParams.id});
                            }]
                        }
                    }).result.then(function(result) {
                        $state.go('guia', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    })
                }]
            });
    });
